import React, { useContext } from "react";
import { Skeleton } from "@mui/material";
import { ToggleSummaryProvider } from "../GridViewFunction/ToggleSummary";

const InvoiceTotal = ({ column, data, value }: any) => {
  const { totalLading } = useContext(ToggleSummaryProvider);
  if (totalLading) return <Skeleton />;
  const columnName = column?.getColId();
  return (
    <div
      style={{
        display: "flex",
        fontSize: "12px",
        fontWeight: 500,
        color: "#333333",
      }}
    >
      <span style={{ display: "flex", alignItems: "center" }}>
        $
        {(value ?? (data?.[columnName] || 0))?.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}
      </span>
    </div>
  );
};
export default InvoiceTotal;
